import React from "react";
import { Typography, withStyles, WithStyles } from "@material-ui/core";
import { styles } from "./InternalRegisterInfo.styles";
import UniversalTable from "../UniversalTable/UniversalTable";
import configuration from "../../../utilities/configuration";
import { IUniversalTableColumn } from "../UniversalTable/interfaces";

const IIQRoles = {
    Development: ["DataShop - Development - User", "DataShop - Development - EurexUser"],
    Test: ["DataShop - Test - User", "DataShop - Test - EurexUser"],
    Simu: ["DataShop - Simulation - User", "DataShop - Simulation - EurexUser"],
    Prod: ["DataShop - Production - User", "DataShop - Production - EurexUser"]
};
const IIQRolesDescriptions = [
    "Regular shop user",
    "Regular shop user with additional rights for Eurex employees (order quota)"
];

export interface IInternalRegistrationInfoProps extends WithStyles<typeof styles> {}
const InternalRegistrationInfoPure: React.FunctionComponent<IInternalRegistrationInfoProps> = ({ classes }) => {
    const getRoles = (env: string) => {
        const roles = IIQRoles[env] || IIQRoles["Prod"];
        return roles.map((role, index) => ({
            role,
            description: IIQRolesDescriptions[index]
        }));
    };

    const rolesColumns: IUniversalTableColumn[] = [
        {
            title: "Role",
            field: "role",
            type: "text",
            sortDisable: true
        },
        {
            title: "Description",
            field: "description",
            type: "text",
            sortDisable: true
        }
    ];
    return (
        <>
            <Typography variant="h5" gutterBottom>
                Dear colleague, <br />
                <br />
                As an internal user, please request your user role in IIQ in order to get access to the Data Shop. The
                following roles can be requested:
            </Typography>
            <div className={classes.table}>
                <UniversalTable pagingDisabled columns={rolesColumns} data={getRoles(configuration.envName)} dense />
            </div>
            <Typography variant="h5" gutterBottom>
                Should you have any further questions, please do not hesitate to contact us at +49-(0) 69-2 11-1 10 33
                or send us an e-mail to <a href="mailto:hdp@deutsche-boerse.com.">hdp@deutsche-boerse.com.</a>.<br />
                <br />
                Kind regards,
                <br />
                Datashop Support
            </Typography>
        </>
    );
};

export const InternalRegistrationInfo = withStyles(styles)(InternalRegistrationInfoPure);
